import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { Subject } from 'rxjs';
import { PharmacieDto } from '../DTO/pharmacie.dto';
import { ContactSupportDto } from '../DTO/contact-support.dto';

@Injectable({
  providedIn: 'root'
})
export class PharmacieService {

  private PHARMACIE_ENDPOINT = environment.API_ENDPOINT + '/pharmacies';

  public wantLogout = false;

  constructor(private httpClient: HttpClient) {
  }

  getMe() {
    return this.httpClient.get(this.PHARMACIE_ENDPOINT + '/me');
  }

  logout() {
    this.wantLogout = true;
    return this.httpClient.get(environment.API_ENDPOINT + '/logout');
  }

  putPharmacie(pharmacie: PharmacieDto) {
    return this.httpClient.put(this.PHARMACIE_ENDPOINT + '/me', JSON.stringify(pharmacie));
  }

  postContactSupport(contactSupport: ContactSupportDto) {
    return this.httpClient.post(this.PHARMACIE_ENDPOINT +'/contact-support', JSON.stringify(contactSupport));
  }

  getMeForAuth() {
    return this.httpClient.get(environment.API_ENDPOINT +'/2fa/pharmacies/me');
  }

  sendAuthCode(code: string) {
    return this.httpClient.post(environment.API_ENDPOINT +'/2fa', JSON.stringify({'code': code}));
  }
  getIsEquipe(){
    return this.httpClient.get(this.PHARMACIE_ENDPOINT + '/me/isEquipe');
  }

}
